import { rootApi } from "../api/rootApi";

export const dreamGiftsApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllDreamGifts: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/dream-gift/list/?zoneId=${params.zoneId}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
  }),
});

export const { useGetAllDreamGiftsMutation } = dreamGiftsApi;
